import styled, { css } from "styled-components";
import { Usermenu, UserMenuItem } from "../styles";
import { MenuElement } from "../../common-style";
import { IStyleProps } from "./interfaces";


const christmasBackground = "#5aa3b9";
const christmasColor = "#076480";

export const Container = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    padding: 2px 6px;
    margin: 10px 2px;
    font-size: 18px;
    cursor: pointer;
    background-color: transparent;
    border: none;
    outline: none;
    color: ${p => p.theme.c.snow};
    margin-right: -4px;
    polygon {
        fill: ${p => p.theme.c.dark};
    }
`;

export const LanguageDropdown = styled(Usermenu)<IStyleProps>`
    top: calc(100% + 10px);
    width: 306px;
    
    ${p =>
        p.theme.xs(css`
            right: -59px;
            min-width: 260px;
        `)}
    ${p => p.isChristmas && css`
        background-color: ${christmasBackground};
        border-radius: 8px;
        right: 4px !important;
    `}
    h4 {
        margin: 6px;
        font-size: 16px;
    }
`;

export const LanguageCategory = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
`;

export const LanguageOption = styled.div<IStyleProps>`
    ${MenuElement}
    ${UserMenuItem}
    height: auto;
    line-height: 21px;
    display: flex !important;
    padding: 6px;
    font-size: 16px;
    ${p => p.isChristmas && css`
        color: ${christmasColor};
    `}
    ${p =>
        p.isActive &&
        css`
            color: white;
        `}
    ${p =>
        p.theme.xs(css`
            margin: 0 4px;
            font-weight: 400;
            line-height: 24px;
        `)}
`;

export const Flag = styled.img`
    width: 30px;
    height: 21px;
    margin-right: 12px;
    box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.4);
`;

export const Caret = styled.div<IStyleProps>`
    margin-left: -2px;
    ${p => p.isChristmas && css`
        svg polygon {
            fill: ${christmasBackground};
        }
    `}
`;